/* ============================================================
   FLG PHONE v2, 2026-10-09. Two behaviours, phone only.
     1. the single pinned bar, revealed after the photographs
     2. the Facts and Story collapse
   Pairs with assets/flg-phone.css. Both are loaded once per
   page by snippets/flg-phone.liquid, rendered from
   sections/flg-phone-loader.liquid on the product template.

   ------------------------------------------------------------
   v2 FIXES A SILENT NO-OP. READ bandBody() BEFORE CHANGING IT.
   ------------------------------------------------------------
   v1 took host.firstElementChild as the thing to clamp. Every
   FLG section emits its stylesheet and its inline <style>
   BEFORE its markup, so the first element child of a
   shopify-section wrapper is a <link>, not the section.

   The clamp class landed on a zero-height <link>. The height
   test then found scrollHeight of 0, concluded the band was
   already short enough to need no control, and hid the button
   it had just created. No error, nothing in the console, and
   the page stayed at 12,067px. The button was in the DOM the
   whole time at zero height.

   bandBody() now skips LINK, STYLE, SCRIPT and NOSCRIPT and
   takes the first real element. Do not replace it with
   firstElementChild, children[0], or querySelector('div').

   ------------------------------------------------------------
   WHY THE COLLAPSE IS DRIVEN FROM HERE, NOT FROM THE SECTIONS
   ------------------------------------------------------------
   It could have been markup inside flg-parcel-facts.liquid and
   flg-parcel-story.liquid. It is here because both are large,
   shared by every parcel, and rewriting them wholesale to add
   one button is a far bigger change surface than adding a
   class from outside. The cost: this file reaches into two
   sections it does not own, by id suffix. Rename either one
   and the collapse silently stops and the page silently goes
   back to seventeen screens. BANDS below is the whole
   coupling, in one place.

   NOTHING HERE HARDCODES A CLASS IT CANNOT RELY ON
   The call bar names its own elements .fb + section.id, which
   is generated per section, so the dock is found through its
   data-flg-callbar wrapper. The hold band's sticky bar is
   found structurally, as the fixed position element inside the
   hold section, so renaming it cannot break this.

   THE CLIPPED TEXT IS NEVER REMOVED
   max-height plus overflow is a visual clip. The content stays
   in the DOM, in the markup Google receives, findable by
   in-page search and readable by a screen reader. Never turn
   this into display:none and never unmount it, or you quietly
   halve the indexed body of every parcel page.
   ============================================================ */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width:750px)');

  var BANDS = [
    { sel: '[id$="__flg_parcel_facts"]', h: 620, label: 'See everything on the record' },
    { sel: '[id$="__flg_parcel_story"]', h: 540, label: 'Read the rest' }
  ];

  function onPhone() { return mq.matches; }

  /* The first element that is actually rendered. See the v2
     note at the top: a section's <link> and <style> come
     first and both have zero height. */
  function bandBody(host) {
    var kids = host.children;
    for (var k = 0; k < kids.length; k++) {
      var t = kids[k].tagName;
      if (t === 'LINK' || t === 'STYLE' || t === 'SCRIPT' || t === 'NOSCRIPT') continue;
      return kids[k];
    }
    return null;
  }

  function listen(fn) {
    window.addEventListener('scroll', fn, { passive: true });
    window.addEventListener('resize', fn, { passive: true });
    if (mq.addEventListener) { mq.addEventListener('change', fn); }
    else if (mq.addListener) { mq.addListener(fn); }
  }

  function dock() {
    var wrap = document.querySelector('[data-flg-callbar]');
    if (!wrap) return;
    var bar = wrap.querySelector('.dock');
    if (!bar) return;

    var gallery = document.querySelector('[id$="__flg_parcel_gallery"]');
    var hold = document.querySelector('[id$="__flg_parcel_hold"]');

    var holdBar = null;
    if (hold) {
      var kids = hold.querySelectorAll('*');
      for (var i = 0; i < kids.length; i++) {
        if (getComputedStyle(kids[i]).position === 'fixed') { holdBar = kids[i]; break; }
      }
    }

    var past = function () {
      if (gallery) return gallery.getBoundingClientRect().bottom < 0;
      return (window.pageYOffset || 0) > window.innerHeight;
    };

    var state = null;
    var apply = function () {
      if (!onPhone()) {
        bar.classList.remove('flg-dock-on');
        document.body.classList.remove('flg-dock-up');
        if (holdBar) holdBar.style.display = '';
        state = null;
        return;
      }
      var want = past();
      if (want === state) return;
      state = want;
      bar.classList.toggle('flg-dock-on', want);
      document.body.classList.toggle('flg-dock-up', want);
      if (holdBar) holdBar.style.display = want ? 'none' : '';
    };

    listen(apply);
    apply();
  }

  function clamp(spec) {
    var host = document.querySelector(spec.sel);
    if (!host || host.__flgClamp) return;
    var inner = bandBody(host);
    if (!inner) return;
    host.__flgClamp = true;

    var bg = getComputedStyle(inner).backgroundColor;
    if (!bg || bg === 'transparent' || bg.indexOf('rgba(0, 0, 0, 0') === 0) bg = '#ffffff';

    if (!inner.id) inner.id = 'flgclamp' + Math.random().toString(36).slice(2, 8);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'flg-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', inner.id);
    btn.textContent = spec.label;
    host.appendChild(btn);

    var open = false;

    var sync = function () {
      if (!onPhone()) {
        inner.classList.remove('flg-clamp', 'flg-open');
        btn.style.display = 'none';
        return;
      }
      inner.style.setProperty('--flg-clamp-h', spec.h + 'px');
      inner.style.setProperty('--flg-clamp-bg', bg);
      inner.classList.add('flg-clamp');
      inner.classList.toggle('flg-open', open);
      btn.style.display = '';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : spec.label;
      if (!open && inner.scrollHeight <= spec.h + 40) {
        inner.classList.remove('flg-clamp');
        btn.style.display = 'none';
      }
    };

    btn.addEventListener('click', function () {
      open = !open;
      sync();
      if (!open) {
        var top = host.getBoundingClientRect().top + (window.pageYOffset || 0);
        var head = parseInt(getComputedStyle(document.documentElement)
          .getPropertyValue('--flg-sticky-top'), 10) || 96;
        window.scrollTo(0, Math.max(0, top - head));
      }
    });

    window.addEventListener('resize', sync, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    sync();

    if (document.readyState !== 'complete') window.addEventListener('load', sync);
  }

  function boot() {
    dock();
    for (var i = 0; i < BANDS.length; i++) clamp(BANDS[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
